import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'deductions_are_not_voluntarily_accepted_workers'

export const dataPointDefinition = {
  retracedId: 'deductions_are_not_voluntarily_accepted_workers',
  name: 'Deductions are not voluntarily accepted by workers',
  description:
    'The intent of this question is to understand if workers voluntarily accept all deductions (other than those that are legally required).',
  meta: {
    slcpMeta: {
      key: 'wb-wage-100x',
      number: 'WB-WAGE-121-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-wage-100x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35900,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
